import styled from 'styled-components';

export const UserCount = styled.div`
  margin-top: 8px;
`;

export const AddAccountRow = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
`;
